// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Card from '@liquidweb-dev/undercurrent/Card';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import { useInput } from 'components/LWForm';
import HookedCheckbox from 'components/Form/HookedCheckbox';

/**
 * @param {object} props
 * @param {string} [props.inputName]
 */
const DataLossConfirmation = ({ inputName = 'confirm' }) => {
	const { error } = useInput(inputName);

	return (
		<Card
			sx={{
				padding: 200,
				display: 'flex',
				flexDirection: 'column',
				gap: 200,
				borderColor: ({ vars }) =>
					error ? vars.palette.uc.danger.border.strong : undefined,
			}}
		>
			<Box>
				<Typography
					component="p"
					variant="body-md"
					sx={{
						fontWeight: 500,
					}}
				>
					Data will be overwritten
				</Typography>
				<Typography component="p" variant="body-sm">
					Current data on the selected server will be overwritten once reimaging
					has started
				</Typography>
			</Box>
			<HookedCheckbox
				name={inputName}
				label="Confirm and acknowledge"
				required
			/>
		</Card>
	);
};

export default DataLossConfirmation;
